import React, {Fragment, useEffect, useState} from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import {useDispatch, useSelector} from "react-redux";
import Loader from "../../components/Loader/Loader";
import savingDefaultsLottie from '../../assets/images/saving_defaults_lottie.json';
import Switch from "react-switch";
import {getOciThreshold, postEnableDisableOciThreshold, postUpdateOciThreshold} from "../../store/actions";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  Table,
  TabPane,
  Tooltip,
  UncontrolledAccordion
} from "reactstrap";
import {getOciLogo, getOciName} from "helpers/component_helpers";
import classnames from "classnames";

const OciThreshold = props => {
  const dispatch = useDispatch();
  const [thresholdBreakdown, setThresholdBreakdown] = useState({});
  const [dynamicThresholdBreakdown, setDynamicThresholdBreakdown] = useState({});

  const [subscribemodal, setSubscribemodal] = useState(false);

  const [changedValues, setchangedValues] = useState({});
  const [changedValuesDynamic, setchangedValuesDynamic] = useState({});
  const [modalChangedValues, setModalChangedValues] = useState({});
  const [modalChangedKey, setModalChangedKey] = useState();
  const [ttop, settop] = useState(false);
  const [dttop, setdtop] = useState(false);
  const changeHeaders = ['Key', 'Old Value', 'New Value']

  const {ociThreshold} = useSelector(state => ({
    ociThreshold: state.OCI.ociThreshold || []
  }));

  const [isLoading, setIsLoading] = useState(false);


  // const [tooltipOpen, setTooltipOpen] = useState(false);
  // const [currentIndex, setCurrentIndex] = useState(null);
  //
  // const toggle = (index) => {
  //     setTooltipOpen(!tooltipOpen);
  //     setCurrentIndex(index);
  // };
  // const newCurrentIndex = useRef(null);
  // const handleMouseOver = (index) => {
  //     setCurrentIndex(index);
  //     newCurrentIndex.current = index;
  //     setTooltipOpen(true);
  // };
  //
  // const handleMouseOut = () => {
  //     setTooltipOpen(false);
  //     newCurrentIndex.current = null;
  //     setCurrentIndex(null);
  // };


  useEffect(() => {
    dispatch(getOciThreshold());
  }, [getOciThreshold]);


  useEffect(() => {
    const threshold_breakdown = {};
    const dynamic_threshold_breakdown = {};
    if (ociThreshold.length > 0) {
      ociThreshold.forEach((threshold) => {
        if (threshold.threshold_type === 'Dynamic') {
          if (!dynamic_threshold_breakdown[threshold.resource_type]) {
            dynamic_threshold_breakdown[threshold.resource_type] = [];
          }
          dynamic_threshold_breakdown[threshold.resource_type].push(threshold);
        } else {
          if (!threshold_breakdown[threshold.resource_type]) {
            threshold_breakdown[threshold.resource_type] = [];
          }
          threshold_breakdown[threshold.resource_type].push(threshold);
        }
      });
      setThresholdBreakdown(threshold_breakdown);
      setDynamicThresholdBreakdown(dynamic_threshold_breakdown);
    }
  }, [ociThreshold]);
  const [valueError, setValueError] = useState({
    interval_in_minutes: '',
    trigger_delay: ''
  });

  const handleFormChange = (index, event, threshold_title) => {
    const values = [...thresholdBreakdown[threshold_title]];
    const changed_values = {...changedValues};
    const title = values[index]['metric']['name'];
    if (event.target.name === 'interval_in_minutes') {
      if (event.target.value === "") {
        setValueError({...valueError, [event.target.name]: 'Value cannot be empty'});
      } else if (event.target.value < 1) {
        setValueError({...valueError, [event.target.name]: 'Value cannot be less than 1'});
        return;
      } else if (event.target.value > 1440) {
        setValueError({...valueError, [event.target.name]: 'Value cannot be greater than 1440'});
        return;
      } else if (event.target.value < 1) {
        setValueError({...valueError, [event.target.name]: 'Value cannot be less than 1'});
        return;
      } else {
        setValueError({...valueError, [event.target.name]: ''});
      }
    }
    if (event.target.name === 'trigger_delay') {
      if (event.target.value === "") {
        setValueError({...valueError, [event.target.name]: 'Value cannot be empty'});
      } else if (event.target.value < 1) {
        setValueError({...valueError, [event.target.name]: 'Value cannot be less than 1'});
        return;
      } else if (event.target.value > 1440) {
        setValueError({...valueError, [event.target.name]: 'Value cannot be greater than 1440'});
        return;
      } else if (event.target.value < 1) {
        setValueError({...valueError, [event.target.name]: 'Value cannot be less than 1'});
        return;
      } else {
        setValueError({...valueError, [event.target.name]: ''});
      }
    }
    if (changed_values[threshold_title] === undefined) {
      changed_values[threshold_title] = {}
    }
    if (changed_values[threshold_title][title] === undefined) {
      changed_values[threshold_title][title] = {}
    }
    if (changed_values[threshold_title][title][event.target.name] === undefined) {
      changed_values[threshold_title][title][event.target.name] = {}
      changed_values[threshold_title][title][event.target.name] = {
        'id': values[index]['id'],
        'title': values[index]['metric']['name'],
        'name': event.target.name,
        'old': values[index][event.target.name],
        'new': event.target.value
      }
    } else {
      if (changed_values[threshold_title][title][event.target.name]['old'] === event.target.value) {
        delete changed_values[threshold_title][title][event.target.name]
      } else {
        changed_values[threshold_title][title][event.target.name]['new'] = event.target.value
      }
    }
    if (Object.keys(changed_values[threshold_title][title]).length !== 0) {
      changed_values[threshold_title][title].threshold_id = values[index]['id']
    }
    setchangedValues(changed_values);
    values[index][event.target.name] = event.target.value;
  };

  const handleSubmit = (key) => {
    const alerts_update = [];
    if (changedValues[key]) {
      Object.entries(changedValues[key]).map(([parent_key, changedValue], index) => {
        const payload = {
          'threshold_id': changedValue.threshold_id,
        };
        Object.entries(changedValue).map(([key, value], index2) => {
          payload[value.name] = value.new;
        });
        alerts_update.push(payload);
      });
    }

    if (changedValuesDynamic[key]) {
      Object.entries(changedValuesDynamic[key]).map(([parent_key, changedValue], index) => {
        const payload = {
          'threshold_id': changedValue.threshold_id,
        };
        Object.entries(changedValue).map(([key, value], index2) => {
          payload[value.name] = value.new;
        });
        alerts_update.push(payload);
      });
    }

    alerts_update.map((alert, index) => {
      dispatch(postUpdateOciThreshold(alert));
    });

    setSubscribemodal(false);
    const changed_values = {...changedValues};
    const changed_values_dynamic = {...changedValuesDynamic};
    delete changed_values_dynamic[key]
    delete changed_values[key];
    setchangedValues(changed_values);
    setchangedValuesDynamic(changed_values_dynamic)
  };


  const handleSave = (threshold_title) => {
    const mergedChangedValues = {...changedValues, ...changedValuesDynamic};

    if (mergedChangedValues[threshold_title]) {
      setModalChangedValues(mergedChangedValues[threshold_title]);
      setModalChangedKey(threshold_title);
      setSubscribemodal(true);
    }
  };

  const headers = ['Statistic', 'Metric Name', 'Operator', 'Unit', 'Threshold Value', 'Interval', 'Trigger Delay', 'Action']

  const ThresholdCondition = ['>', '<', '<=', '>=', '==', 'absent()', 'in', 'not in'];

  const OffSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  const startLoading = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 4000);
  };

  const handleDisable = (alert_id) => {
    const payload = {
      'threshold_id': alert_id,
      'enable': false,
    }
    dispatch(postEnableDisableOciThreshold(payload));
  };

  const handleEnable = (alert_id) => {
    const payload = {
      'threshold_id': alert_id,
      'enable': true,
    }
    dispatch(postEnableDisableOciThreshold(payload));
  };

  const [toggles, setToggles] = useState({});

  useEffect(() => {
    const initialToggles = {};
    if (thresholdBreakdown) {
      Object.keys(thresholdBreakdown).forEach(key => {
        const thresholdsArray = thresholdBreakdown[key];
        thresholdsArray.forEach(threshold => {
          initialToggles[threshold.id] = threshold.enabled === null ? true : threshold.enabled;
        });
      });
    }
    if (dynamicThresholdBreakdown) {
      Object.keys(dynamicThresholdBreakdown).forEach(key => {
        const thresholdsArray = dynamicThresholdBreakdown[key];
        thresholdsArray.forEach(threshold => {
          initialToggles[threshold.id] = threshold.enabled === null ? true : threshold.enabled;
        });
      });
    }
    setToggles(initialToggles);
  }, [thresholdBreakdown, dynamicThresholdBreakdown]);


  const toggleAlert = (index3, alertId) => {
    const updatedToggles = {...toggles};
    updatedToggles[alertId] = !updatedToggles[alertId];
    setToggles(updatedToggles);

    if (!updatedToggles[alertId]) {
      setTimeout(() => {
        handleDisable(alertId);
      }, 1000);
    } else {
      setTimeout(() => {
        handleEnable(alertId);
      }, 1000);
    }
  };

  const [activeTab, setactiveTab] = useState("1");
  const [tanomaly, settanomaly] = useState(false);

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };
  return (
    <React.Fragment>
      <Row>
        <Col lg="8">
          <Breadcrumbs
            title={"Oci Thresholds"}
            breadcrumbItem={"Oci Thresholds"}
          />
        </Col>
      </Row>
      <Nav pills className="nav-custom">
        <NavItem className="nav-item-custom">
          <NavLink
            className={classnames({
              active: activeTab === "1",
            })}
            onClick={() => {
              toggleTab("1");
            }}
          >
            <span className="d-sm-block">Static Alert Thresholds</span>
          </NavLink>
        </NavItem>
        <NavItem className="nav-item-custom">
          <NavLink
            className={classnames({
              active: activeTab === "2",
            })}
            onClick={() => {
              toggleTab("2");
            }}
          >
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <span className="d-sm-block" style={{marginRight: '10px'}}>Anomaly Detection Alert Thresholds</span>
              <span
                id="TooltipAnomaly"
                onMouseOver={() => settanomaly(true)}
                onMouseLeave={() => settanomaly(false)}
                className="alert-icon"
                style={{marginRight: '10px'}}
              >
                  <i className="mdi mdi-information-outline text-warning fix-flicker"/>
                </span>
              <Tooltip
                placement="right"
                isOpen={tanomaly}
                target="TooltipAnomaly"
                toggle={() => {
                  settanomaly(!tanomaly);
                }}
                style={{
                  border: "2px solid #f1b44c",
                  borderRadius: "10px",
                  backgroundColor: "#2a3042",
                  zIndex: 1
                }}
                className="fix-flicker"
              >
                Anomaly Alerts are based on standard deviation of metric
              </Tooltip>
            </div>
          </NavLink>
        </NavItem>
      </Nav>
      <hr style={{border: "1px solid #556ee6", backgroundColor: "#556ee6", width: "100%", marginTop: "-1px",}}/>

      <TabContent activeTab={activeTab} className="py-4">
        <TabPane tabId="1">
          <div>
            <Row>
              <Col lg={12}>
                <UncontrolledAccordion defaultOpen={"1"}>
                  {
                    Object.entries(thresholdBreakdown).map(([key, value], index) => {
                      return (
                        <Fragment key={index}>
                          <AccordionItem>
                            <AccordionHeader targetId={(index + 1).toString()}>
                              <Row className="full-width">
                                <Col lg="6">
                                  <h5 className="change-table-text">
                                    <img src={getOciLogo(key)} className="resource-logo"></img>
                                    <span className="text-primary">{getOciName(key)}</span>
                                  </h5>
                                </Col>
                                <Col lg="6">
                                  {
                                    (changedValues[key] !== undefined && Object.entries(changedValues).length > 0) ?
                                      <button
                                        type="button"
                                        className="btn btn-primary bx-pull-right w-md mt-2"
                                        onClick={() => {
                                          handleSave(key);
                                        }}
                                        disabled={JSON.stringify(valueError) !== JSON.stringify({
                                          interval_in_minutes: '',
                                          trigger_delay: ''
                                        })}
                                      >
                                        Save Default Threshold
                                      </button> : null
                                  }
                                </Col>
                              </Row>
                            </AccordionHeader>
                            <AccordionBody accordionId={(index + 1).toString()}>
                              <div className="table-responsive react-table">
                                <Table bordered hover className="table-purple">
                                  <thead className="table-light table-nowrap">
                                  <tr>
                                    {headers.map((header, index2) => (
                                      <th key={index2}>
                                        <div className="mb-2 text-white">
                                          {header}
                                          {header === 'Interval' && valueError.interval_in_minutes &&
                                            <p className="invalid-error">{valueError.interval_in_minutes}</p>}
                                          {header === 'Trigger Delay' && valueError.trigger_delay &&
                                            <p className="invalid-error">{valueError.trigger_delay}</p>}
                                        </div>
                                      </th>
                                    ))}
                                  </tr>
                                  </thead>
                                  <tbody>
                                  {
                                    value.map((threshold, index3) => {
                                      return (
                                        <Fragment key={index3}>
                                          <tr>
                                            <td className="text-white">
                                              {threshold?.statistic}
                                            </td>
                                            <td className="text-white">
                                              {threshold.metric.name}
                                            </td>
                                            <td>
                                              <div className="input">
                                                <select
                                                  id="formrow-InputState"
                                                  name="operator"
                                                  className="custom_select"
                                                  value={threshold.operator}
                                                  onChange={event => handleFormChange(index3, event, key)}
                                                >
                                                  {ThresholdCondition.map((item, key1) => (
                                                    <option
                                                      key={key1}
                                                      value={item}>{item}</option>))}
                                                </select>
                                              </div>
                                            </td>
                                            <td className="text-white">
                                              {threshold.unit}
                                            </td>
                                            <td>
                                              {["in", "not in"].includes(threshold?.operator) ?
                                                <div className="d-flex">
                                                  <input
                                                    type="number"
                                                    value={threshold?.lower_threshold || ""}
                                                    name="lower_threshold"
                                                    className="input w-50 mx-1"
                                                    id="autoSizingInputGroup"
                                                    style={{width: '100px'}}
                                                    placeholder="Lower Threshold"
                                                    onChange={event => handleFormChange(index3, event, key)}
                                                  />
                                                  <input
                                                    type="number"
                                                    value={threshold?.upper_threshold || ""}
                                                    name="upper_threshold"
                                                    className="input w-50 mx-1"
                                                    id="autoSizingInputGroup"
                                                    style={{width: '100px'}}
                                                    placeholder="Upper Threshold"
                                                    onChange={event => handleFormChange(index3, event, key)}
                                                  />
                                                </div>
                                                : threshold?.operator !== "absent()" ?
                                                  <input
                                                    type="number"
                                                    value={threshold?.threshold_value || ""}
                                                    name="threshold_value"
                                                    className="input"
                                                    style={{width: '100px'}}
                                                    id="autoSizingInputGroup"
                                                    placeholder="Threshold Value"
                                                    onChange={event => handleFormChange(index3, event, key)}
                                                  />
                                                  : null
                                              }
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                value={threshold.interval_in_minutes}
                                                name="interval_in_minutes"
                                                className="input text-center"
                                                id="autoSizingInputGroup"
                                                placeholder="Interval"
                                                style={{width: '100px'}}
                                                onChange={event => handleFormChange(index3, event, key)}
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                value={threshold?.trigger_delay}
                                                name="trigger_delay"
                                                className="input text-center"
                                                id="autoSizingInputGroup"
                                                placeholder="Trigger Delay"
                                                style={{width: '80px'}}
                                                onChange={event => handleFormChange(index3, event, key)}
                                              />
                                            </td>
                                            <td>
                                              {
                                                threshold?.enabled === true || threshold?.enabled === null ?
                                                  (
                                                    <>
                                                      <div
                                                        id="TooltipTop"
                                                        onMouseOver={() => settop(true)}
                                                        onMouseLeave={() => settop(false)}
                                                        className="alert-icon"
                                                      >
                                                        <Switch
                                                          key={toggles[threshold.id]}
                                                          uncheckedIcon={
                                                            <OffSymbol/>}
                                                          checkedIcon={
                                                            <OnSymbol/>}
                                                          className="me-1 mb-sm-8 mb-2"
                                                          onColor="#34c38f"
                                                          offColor="#f46a6a"
                                                          height={20}
                                                          width={44}
                                                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                          activeBoxShadow="0px 0px 1px 5px"
                                                          onChange={() => toggleAlert(index3, threshold.id)}
                                                          checked={toggles[threshold.id] || false}
                                                        /></div>
                                                      <Tooltip
                                                        placement="top"
                                                        isOpen={ttop}
                                                        target="TooltipTop"
                                                        toggle={() => {
                                                          settop(!ttop);
                                                        }}
                                                        style={{
                                                          border: "2px solid #f1b44c",
                                                          borderRadius: "10px",
                                                          backgroundColor: "#2a3042",
                                                          zIndex: 1
                                                        }}
                                                        className="fix-flicker"
                                                      >
                                                        Enable/Disable
                                                        metric
                                                      </Tooltip>
                                                    </>
                                                  ) :
                                                  (
                                                    <>
                                                      <div
                                                        id="DisabledTooltipTop"
                                                        onMouseOver={() => setdtop(true)}
                                                        onMouseLeave={() => setdtop(false)}
                                                        className="alert-icon"
                                                      ><Switch
                                                        key={toggles[threshold.id]}
                                                        uncheckedIcon={
                                                          <OffSymbol/>}
                                                        checkedIcon={
                                                          <OnSymbol/>}
                                                        className="me-1 mb-sm-8 mb-2"
                                                        offColor="#f46a6a"
                                                        onColor="#34c38f"
                                                        height={20}
                                                        width={44}
                                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                        activeBoxShadow="0px 0px 1px 5px"
                                                        onChange={() => toggleAlert(index3, threshold.id)}
                                                        checked={toggles[threshold.id] || false}
                                                      /></div>
                                                      <Tooltip
                                                        placement="top"
                                                        isOpen={dttop}
                                                        target="DisabledTooltipTop"
                                                        toggle={() => {
                                                          setdtop(!dttop);
                                                        }}
                                                        style={{
                                                          border: "2px solid #f1b44c",
                                                          borderRadius: "10px",
                                                          backgroundColor: "#2a3042",
                                                          zIndex: 1
                                                        }}
                                                        className="fix-flicker"
                                                      >
                                                        Enable/Disable
                                                        metric
                                                      </Tooltip>
                                                    </>
                                                  )
                                              }
                                            </td>
                                          </tr>
                                        </Fragment>
                                      )
                                    })
                                  }
                                  </tbody>
                                </Table>
                              </div>
                            </AccordionBody>
                          </AccordionItem>
                        </Fragment>
                      )
                    })
                  }
                </UncontrolledAccordion>
              </Col>
            </Row>
          </div>
        </TabPane>
        <TabPane tabId="2">
          <div>
          </div>
        </TabPane>
      </TabContent>
      <Loader
        isOpen={isLoading}
        lottieJson={savingDefaultsLottie}
        messageHeader="Saving Thresholds"
        message="Please wait while your default thresholds are being updated."
      />
      <Modal
        isOpen={subscribemodal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        size="xl"
        tabIndex="-1"
      >
        <div className="modal-header border-bottom-1 text-center">
          <h4 className="text-primary">Your are about to change the defaults for Oci Thresholds!</h4>
          <button type="button" className="btn-close"
                  onClick={() => {
                    setSubscribemodal(!subscribemodal);
                  }} aria-label="Close">
          </button>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row">
              <div className="col-xl-12">
                <p className="font-size-14 mb-4">This change will affect all the new alerts that will be set up
                  for {modalChangedKey}.</p>
                <div className='w-100 d-flex justify-content-start'>
                  <Table bordered hover className="table-purple">
                    <thead className="table-light table-nowrap">
                    <tr>
                      <th>Threshold Name</th>
                      {changeHeaders.map((header, index) => (
                        <th key={index}>{header}</th>
                      ))}
                    </tr>
                    </thead>

                    {Object.entries(modalChangedValues).map(([parent_key, changedValue], index) => {
                      return (
                        <Fragment key={index}>
                          <tbody>
                          {
                            Object.entries(changedValue).map(([key, value], index2) => {
                              if (key !== 'threshold_id') {
                                return (
                                  <Fragment key={index2}>
                                    <tr>
                                      <td>
                                        {parent_key}
                                      </td>
                                      <td>
                                        {value.name}
                                      </td>
                                      <td>
                                        {value.old}
                                      </td>
                                      <td>
                                        <b>{value.new}</b>
                                      </td>
                                    </tr>
                                  </Fragment>
                                )
                              }
                            })
                          }
                          </tbody>
                        </Fragment>
                      )
                    })}
                  </Table>
                </div>
                <button className="btn btn-primary w-md mt-3"
                        id="button-addon2"
                        onClick={() => {
                          startLoading();
                          handleSubmit(modalChangedKey);
                        }}>
                  Save Alerts
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

OciThreshold.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
  onGetServices: PropTypes.func,
};

export default withRouter(OciThreshold);
